import { render } from "./BreakingChangesWarning.vue?vue&type=template&id=62348ae4&lang=true"
import script from "./BreakingChangesWarning.vue?vue&type=script&lang=js"
export * from "./BreakingChangesWarning.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__